"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BOARD_LABEL = void 0;
exports.generateUniqueVariableName = generateUniqueVariableName;
exports.normalizeVariableName = normalizeVariableName;
exports.setBoardLabel = setBoardLabel;
// eslint-disable-next-line import/no-mutable-exports

// TODO I think this is a bad idea but it's out of scope for me to fix
// eslint-disable-next-line import/no-mutable-exports
let BOARD_LABEL = exports.BOARD_LABEL = 'Observation Deck';
function normalizeVariableName(name) {
  return name.trim().toLowerCase();
}
function generateUniqueVariableName(baseName, existingNames) {
  const taken = new Set(existingNames.map(normalizeVariableName));
  let candidate = baseName;
  let suffix = 2;
  while (taken.has(normalizeVariableName(candidate))) {
    candidate = `${baseName} ${suffix}`;
    suffix += 1;
  }
  return candidate;
}
function setBoardLabel(label) {
  exports.BOARD_LABEL = BOARD_LABEL = label;
}